// extracted by mini-css-extract-plugin
export var typingIndicator = "_qx-0";